export default __webpack_public_path__ + "static/media/logo-lydian-black.c6e80e47.svg";